"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DepositFailed_1 = __importDefault(require("../DepositFailed"));
var navigation_1 = require("next/navigation");
var ui_components_1 = require("@l2p/ui-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var DepositRetryOrFailed = function (props) {
    var searchParams = (0, navigation_1.useSearchParams)();
    var makeRepeatPayIn = (0, swr_hooks_1.useMakeRepeatPayIn)({
        successAction: function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if ((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.payIn) === null || _b === void 0 ? void 0 : _b.repeat) === null || _c === void 0 ? void 0 : _c.payment) === null || _d === void 0 ? void 0 : _d.url) {
                window.location.href = (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.payIn) === null || _f === void 0 ? void 0 : _f.repeat) === null || _g === void 0 ? void 0 : _g.payment) === null || _h === void 0 ? void 0 : _h.url;
            }
        },
    }).makeRepeatPayIn;
    var paymentId = searchParams.get('paymentId');
    var init_retry = searchParams.get('init_retry');
    var prevPaymentId = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (prevPaymentId.current === paymentId)
            return;
        if (paymentId && init_retry) {
            prevPaymentId.current = String(paymentId);
            makeRepeatPayIn({
                input: {
                    transactionId: String(paymentId),
                },
            });
        }
        //eslint-disable-next-line
    }, [paymentId, init_retry]);
    if (!init_retry)
        return react_1.default.createElement(DepositFailed_1.default, __assign({}, props));
    return react_1.default.createElement(ui_components_1.PageLoading, { imageUrl: "/img/logo.svg" });
};
exports.default = DepositRetryOrFailed;
